import React from 'react';

import { MenuAction } from '../menu/MenuAction.view';
import MenuToggler from '../menu-toggler';
import { TestID } from 'src/testID';

export type FieldPropType = {
  header: string;
  sorter: () => void;
};

export const CardListSortSelector: React.FC<{
  fields: FieldPropType[];
  onChange: (field: FieldPropType) => void;
  currentSortBy?: string;
  currentSortAsc?: boolean;
  buttonTestId?: string;
  userMenuTestId?: string;
}> = ({
  fields,
  onChange,
  currentSortBy,
  currentSortAsc = true,
  buttonTestId = TestID.CardListSortSelector,
  userMenuTestId = TestID.CardListSortSelectorMenu,
}) => {
  const anchorPoint = {
    anchor: { hPos: 'right', vPos: 'bottom' },
    popover: { hPos: 'right', vPos: 'top' },
  };
  let sortDir = '';

  if (currentSortBy) {
    sortDir = currentSortAsc ? ' (asc)' : ' (desc)';
  }

  return (
    <div className="card-list__sort-selector">
      <MenuToggler
        anchorPoint={anchorPoint}
        label={`Sort by ${currentSortBy || '(none)'}${sortDir}`}
        labelClassName="btn btn--dropdown btn--small"
        buttonTestId={buttonTestId}
        userMenuTestId={userMenuTestId}
      >
        {fields.map((field) => (
          <MenuAction key={field.header} label={field.header} onClick={() => onChange(field)} />
        ))}
      </MenuToggler>
    </div>
  );
};
